import React, { useReducer, useContext, createContext, Reducer } from "react";
import { testCaseIndexReducer, Actions } from "./reducer";
import { testCaseIndexState, TestCaseIndex } from "./entity";
// import { Reducer } from 'redux';

export const StateContext = createContext<any>({ context: testCaseIndexState });
const { Provider } = StateContext;
interface Args {
  reducer: Reducer<any, any>;
  initState: TestCaseIndex;
  children: any;
}
export const StateProvider = (args: Args) => {
  const { reducer, initState, children } = args;
  console.log({ args });
  return <Provider value={useReducer(reducer, initState)}>{children}</Provider>;
};

export const useStateValue = () => useContext(StateContext);

export {
  testCaseIndexReducer,
  // StateProvider,
  testCaseIndexState,
  Actions
  // useContextValues
};
